import { useEffect, useCallback } from "react";
import { LogOut } from "lucide-react";

const DECOY_URL = "https://www.google.co.uk/search?q=weather";
const REDIRECT_URL = "https://www.google.co.uk";

// Push a decoy entry so pressing "back" after arrival doesn't reveal this site.
function seedDecoyHistory() {
  try {
    if (!window.__yanaDecoyPushed) {
      window.history.replaceState(null, "", window.location.href);
      window.history.pushState({ decoy: false }, "", window.location.href);
      window.__yanaDecoyPushed = true;
    }
  } catch {
    /* ignore */
  }
}

export default function QuickExit() {
  const leave = useCallback(() => {
    try {
      // Replace current history entry so back doesn't return here.
      window.location.replace(DECOY_URL);
      // In case replace is intercepted, force navigation.
      setTimeout(() => {
        window.location.href = REDIRECT_URL;
      }, 150);
    } catch {
      window.location.href = REDIRECT_URL;
    }
  }, []);

  useEffect(() => {
    seedDecoyHistory();

    // Triple-Esc within 1s as an alternative trigger for keyboard users.
    let escTimes = [];
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      const now = Date.now();
      escTimes = escTimes.filter((t) => now - t < 1000);
      escTimes.push(now);
      if (escTimes.length >= 3) {
        leave();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [leave]);

  return (
    <button
      type="button"
      onClick={leave}
      data-testid="quick-exit-button"
      title="Leave this site quickly (press Esc three times)"
      aria-label="Leave this site quickly"
      className="inline-flex items-center gap-1.5 bg-destructive text-white px-3 py-1.5 text-xs font-accent font-semibold tracking-wide hover:bg-destructive/90 transition-colors shadow-sm"
    >
      <LogOut size={13} strokeWidth={2} />
      Leave quickly
    </button>
  );
}
